import { VStack } from "@/components/ui/vstack";
import { Divider } from "@/components/ui/divider";
import React from 'react';
import i18n from 'i18n-js';
import Header from "../../components/basic/Header";
import Footer from "../../components/basic/Footer";
import BackGesture from "../../containers/BackGesture";
import PressableElement from "../../components/basic/PressableElement";
import { switchScreen } from '../../hooks/navigate';

export default function LegalScreen({navigation}) {
    return (
        <BackGesture navigation={navigation}>
            <VStack space='xs' className="flex-1 bg-secondary-50">
                <Header navigation={navigation} options={{ title: i18n.t('sideNavigationDrawer.legal') }} />
                <VStack space='xl' className="flex-1 py-3 mb-70">
                    <PressableElement fontSize='text-2xl' mainText={i18n.t('imprint.header')} pressed={() => switchScreen(navigation, 'Imprint')} />
                    <Divider/>
                    <PressableElement fontSize='text-2xl' mainText={i18n.t('tou.header')} pressed={() => switchScreen(navigation, 'TermsOfUse')}/>
                    <Divider/>
                    <PressableElement fontSize='text-2xl' mainText={i18n.t('dpa.header')} pressed={() => switchScreen(navigation, 'DataSecurity')} />
                    <Divider/>
                    <PressableElement fontSize='text-2xl' mainText={i18n.t('osl.header')} pressed={() => switchScreen(navigation, 'OpenSourceLicense')} />
                </VStack>
                <Footer navigation={navigation} />
            </VStack>
        </BackGesture>
    );
}
